import React from 'react';

function AppStoreButton(props){
  return (
    <>
			<div style={{display: 'inline-block'}}>
				<a target='_blank' href={props.storeLink}><img style={{height: props.size + 'px'}} alt={props.alt} src={props.imgSource}/></a>
			</div>
    </>
  );
};

AppStoreButton.defaultProps = {
	alt: 'Get it on Apple Store',
	imgSource: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg',
	storeLink: 'https://apps.apple.com/au/app/cryptowaves-crypto-rsi-alerts/id6475659965',
	size: 50
};

export default AppStoreButton;
